import localeEsMx from '@angular/common/locales/es-MX';
import localeEsMxExtra from '@angular/common/locales/extra/es-MX';

import { CommonModule, registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MAT_DATE_LOCALE } from "@angular/material/core";
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SwiperModule } from 'swiper/angular';

import { AppClientComponent } from './app.component';
import { AppClientRoutingModule } from './app-routing.module';
import { AppMaterialModule } from './layouts/material/app.material.module';
import { AppShareModule } from '../shared/app.module';
import { AuthenticationInterceptor } from './_appCommon/interceptors/authentication.interceptor';
import { CheckoutComponent } from './layouts/checkout/checkout.component';
import { HomeComponent } from './home/home.component';
import { MainComponent } from './layouts/main/main.component';
import { NavBarResponsiveComponent } from './layouts/navbar/navbar.component';
import { OpenpayFormComponent } from './layouts/checkout/openpay/openpay-form.component';
import { PaynetFormComponent } from './layouts/checkout/paynet/paynet-form.component';
import { ShareModule } from './_appCommon/share.module';
import { ShoppingCart } from 'src/app/shopping-cart';
import { ShoppingCartDataService } from './_dataservices/ShoppingCartDataService';
import { ShoppingCartSidebarComponent } from './layouts/sidebar/shopping-cart-sidebar.component';
import { SpeiFormComponent } from './layouts/checkout/spei/spei-form.component';
import { SuccessfulPurchaseComponent } from './layouts/checkout/openpay/successful-purchase/successful-purchase.component';
import { UserAccessModule } from './user-access/user-access.module';
import { CaseModule } from './catalogs/cases/case.module';
import { PaylinkFormComponent } from './layouts/checkout/paylink/paylink-form.component';
import { CardpayFormComponent } from './layouts/checkout/cardpay/cardpay-form.component';
import { LoadingInterceptor } from 'src/shared/interceptors/loading.interceptor';
import { LoadingGeneralComponent } from 'src/shared/components/loading-general/loading-general.component';
import { LoadingGeneralModule } from 'src/shared/components/loading-general/loading-general.module';
import { CaseFilesManagerComponent } from './catalogs/case-files-manager/case-files-manager.component';
import { CheckoutPendingPaymentComponent } from './layouts/checkout/checkout-pending-payment/checkout-pending-payment.component';
import { OrdersListHomeComponent } from './home/orders/orders-list-home/orders-list-home.component';

registerLocaleData(localeEsMx, localeEsMxExtra);

@NgModule({
  declarations: [
    AppClientComponent,
    CheckoutComponent,
    HomeComponent,
    MainComponent,
    NavBarResponsiveComponent,
    ShoppingCartSidebarComponent,
    OpenpayFormComponent,
    PaynetFormComponent,
    SpeiFormComponent,
    PaylinkFormComponent,
    SuccessfulPurchaseComponent,
    CardpayFormComponent,
    CheckoutPendingPaymentComponent,
    OrdersListHomeComponent,
  ],
  imports: [
    AppClientRoutingModule,
    AppMaterialModule,
    AppShareModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    ShareModule, //don't remove sharemodule from here,
    ShoppingCart,
    SwiperModule,
    UserAccessModule,
    CaseModule,
    LoadingGeneralModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'es-MX' // format date as "DD/MM/YYYY"
    },
    ShoppingCartDataService
  ],
  bootstrap: [AppClientComponent]
})
export class AppClientSharedModule { }
